import SwitchAndGaugeNavigator from './SwitchAndGaugeNavigator'

export default SwitchAndGaugeNavigator
